class QRCodeImage extends HTMLElement {
  #width = 72
  #height = 72
  #alt = ''
  #didRender = false
  #statusObserver = null

  connectedCallback() {
    const widthAttribute = this.getAttribute('width') ?? ''
    this.#width = Number.isNaN(Number.parseInt(widthAttribute, 10))
      ? this.#width
      : Number.parseInt(widthAttribute, 10)
    const heightAttribute = this.getAttribute('height') ?? ''
    this.#height = Number.isNaN(Number.parseInt(heightAttribute, 10))
      ? this.#height
      : Number.parseInt(heightAttribute, 10)
    this.#alt = this.getAttribute('alt') ?? this.#alt

    this.#ensureQrWhenActive()
  }

  disconnectedCallback() {
    this.#statusObserver?.disconnect()
    this.#statusObserver = null
  }

  #ensureQrWhenActive() {
    if (this.#didRender) {
      return
    }

    const chatButton = this.closest('chat-button')
    if (!chatButton) {
      void this.#renderQr()
      return
    }

    if (chatButton.getAttribute('data-modal-whatsapp-status') === 'active') {
      void this.#renderQr()
      return
    }

    if (this.#statusObserver) {
      return
    }

    this.#statusObserver = new MutationObserver(() => {
      if (!this.isConnected) {
        return
      }

      if (chatButton.getAttribute('data-modal-whatsapp-status') !== 'active') {
        return
      }

      this.#statusObserver?.disconnect()
      this.#statusObserver = null
      void this.#renderQr()
    })

    this.#statusObserver.observe(chatButton, {
      attributeFilter: ['data-modal-whatsapp-status'],
      attributes: true
    })
  }

  async #renderQr() {
    if (this.#didRender) {
      return
    }

    this.#didRender = true

    try {
      const { QRCode } = await import('@theme/qr-code-generator')
      if (!this.isConnected) {
        return
      }

      // eslint-disable-next-line no-new -- QRCode renders into the host element from its constructor
      new QRCode(this, {
        text: this.getAttribute('data-identifier') || '',
        width: this.#width,
        height: this.#height,
        alt: this.#alt
      })
    } catch {
      this.#didRender = false
    }
  }
}

if (!customElements.get('qr-code-image')) {
  customElements.define('qr-code-image', QRCodeImage)
}
